import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from "react-i18next";
import {
  User,
  Eye,
  ArrowUpDown,
  AlertTriangle,
} from "lucide-react";

export const FormerWorkersTab = ({ 
  formerWorkers, 
  onRestoreRole, 
  onViewDetails 
}) => {
  const { t } = useTranslation();
  return (
    <Card className="bg-[#0A0A0A] border-white/10">
      <CardContent className="p-4">
        {formerWorkers.length === 0 ? (
          <div className="text-center py-12">
            <User className="w-12 h-12 text-[#475569] mx-auto mb-4" />
            <p className="text-[#94A3B8]">{t('adminWorkers.noFormerWorkers')}</p>
            <p className="text-sm text-[#64748B] mt-1">{t('adminWorkers.formerWorkersDescription')}</p>
          </div>
        ) : (
          <div className="space-y-3">
            <div className="p-3 bg-yellow-500/10 border border-yellow-500/30 rounded-lg mb-4">
              <p className="text-yellow-400 text-sm">
                <AlertTriangle className="w-4 h-4 inline mr-2" />
                {t('adminWorkers.formerWorkersInfo')}
              </p>
            </div>
            {formerWorkers.map((user) => (
              <div key={user.user_id} className="p-4 bg-white/5 rounded-lg border border-white/10 hover:border-yellow-500/30 transition-colors">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-yellow-500/20 flex items-center justify-center">
                      <User className="w-6 h-6 text-yellow-400" />
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <p className="text-white font-medium">{user.name}</p>
                        <span className="px-2 py-0.5 text-xs rounded bg-yellow-500/20 text-yellow-400">
                          {user.role?.replace('_', ' ')}
                        </span>
                      </div>
                      <p className="text-sm text-[#94A3B8]">{user.email}</p>
                      {user.profile?.worker_code && (
                        <p className="text-xs text-[#64748B] font-mono">{t('adminWorkers.formerCode')}: {user.profile.worker_code}</p>
                      )}
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <Button
                      size="sm"
                      onClick={() => onRestoreRole(user.user_id)}
                      className="bg-green-500 text-white hover:bg-green-600"
                    >
                      <ArrowUpDown className="w-4 h-4 mr-1" />
                      {t('adminWorkers.restoreAsWorker')}
                    </Button>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => onViewDetails(user)}
                      className="border-white/20 text-white hover:bg-white/5"
                    >
                      <Eye className="w-4 h-4" />
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
